import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgAlertIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M14.241 5.147c.757-1.397 2.761-1.397 3.518 0l11.32 20.9C29.803 27.38 28.838 29 27.322 29H4.68c-1.516 0-2.48-1.62-1.759-2.953zM16 6.1 4.679 27H27.32z"
        clipRule="evenodd"
      />
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M15 20v-8h2v8z"
        clipRule="evenodd"
      />
      <circle cx={16} cy={23.5} r={1.5} fill="#353C4A" />
    </svg>,
  );
};
export default SvgAlertIcon;
